import { apiClient } from "./client";
import { type Listing } from "./listings";

export interface PriceTrackingResponse {
  status: string;
  message?: string;
}

export interface PriceTrackingListResponse {
  listings: Listing[];
}

export interface IsTrackedResponse {
  isTracked: boolean;
}

class PriceTrackingService {
  async addToTracking(listingId: string): Promise<PriceTrackingResponse> {
    return await apiClient.post<PriceTrackingResponse>("/price-tracking", {
      listing_id: listingId,
    });
  }

  async removeFromTracking(listingId: string): Promise<PriceTrackingResponse> {
    return await apiClient.delete<PriceTrackingResponse>(`/price-tracking/${listingId}`);
  }

  async getTrackedListings(): Promise<PriceTrackingListResponse> {
    return await apiClient.get<PriceTrackingListResponse>("/price-tracking");
  }

  async isTracked(listingId: string): Promise<IsTrackedResponse> {
    return await apiClient.get<IsTrackedResponse>(`/price-tracking/${listingId}/status`);
  }
}

export const priceTrackingService = new PriceTrackingService();
